import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import Login from "@/pages/Login";
import SuperAdmin from "@/pages/SuperAdmin";
import ClinicDashboard from "@/pages/ClinicDashboard";
import PatientChat from "@/pages/PatientChat";
import SignupClinic from "@/pages/SignupClinic";
import Profile from "@/pages/Profile";
import Help from "@/pages/Help";
import PatientPortal from "@/pages/PatientPortal";
import MagicLogin from "@/pages/MagicLogin";
import DistributionKit from "@/pages/DistributionKit";
import "@/App.css";

function RoleRoute({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Root() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return <Navigate to="/super-admin" replace />;
  if (user.role === "patient") return <Navigate to="/patient" replace />;
  return <Navigate to="/clinic" replace />;
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup-clinic" element={<SignupClinic />} />
            <Route path="/super-admin" element={<RoleRoute roles={["super_admin"]}><SuperAdmin /></RoleRoute>} />
            <Route path="/clinic" element={<RoleRoute roles={["clinic_admin", "doctor"]}><ClinicDashboard /></RoleRoute>} />
            <Route path="/profile" element={<RoleRoute roles={["clinic_admin", "doctor", "super_admin"]}><Profile /></RoleRoute>} />
            <Route path="/help" element={<Help />} />
            <Route path="/distribution-kit" element={<RoleRoute roles={["clinic_admin", "doctor"]}><DistributionKit /></RoleRoute>} />
            <Route path="/patient" element={<RoleRoute roles={["patient"]}><PatientPortal /></RoleRoute>} />
            <Route path="/magic-login" element={<MagicLogin />} />
            <Route path="/chat" element={<PatientChat />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
